<template id="slidercom">
  <div :id="idcarousel" class="parentclass carousel slide" data-ride="carousel">
    <slot name="carIndicators"></slot>
    <div class="carousel-inner" role="listbox">
      <slot name="imgslot"></slot>
    </div>
    <a class="carousel-control-prev" :href="'#'+idcarousel" role="button" data-slide="prev" v-if="lengthban > 1">
      <span class="fa fa-angle-left" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" :href="'#'+idcarousel" role="button" data-slide="next" v-if="lengthban > 1">
      <span class="fa fa-angle-right" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>

<script>

  export default {
    name: 'slidercom',
    props: ['idcarousel', 'lengthban']
  }
</script>


<style lang="css" scoped>
  @media screen and (max-width: 768px) {
    .carousel-item {
      height: auto;
    }

    .carousel-item.active, .carousel-item-next, .carousel-item-prev {
      display: block;
    }

    .carousel-item > img {
      position: static;
    }
  }

  .navlist li a, .navlist li {
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 400;
  }

  .navlist li a:hover {
    color: #117a7a !important;
  }
</style>



// WEBPACK FOOTER //
// carouselSlider.vue?3810d0eb